import { jsx } from "react/jsx-runtime";
import { JSONPath } from "jsonpath-plus-browser";
import "lodash.find";
import "react";
import "../../../common/UI/Loaders/Activity.js";
import "@flatfile/design-system";
import "react-i18next";
import "../Lookup/Styles.js";
import "match-sorter";
import Renderer$1 from "../Lookup/Renderer.js";
import { getCellValueIsEmpty } from "../../../utils/cells.js";
function createMessageMap(cell, messages) {
  const messageMap = /* @__PURE__ */ new Map();
  let globalMessage;
  for (const message of messages) {
    if (message.path == null || message.path == void 0) {
      globalMessage = message.message;
      return [/* @__PURE__ */ new Map(), globalMessage];
    }
  }
  if (!globalMessage) {
    for (const message of messages) {
      if (typeof message.path === "string") {
        const listItem = JSONPath({
          path: message.path,
          json: cell,
          wrap: false
        });
        messageMap.set(listItem, message.message);
      }
    }
  }
  return [messageMap, globalMessage];
}
const getFormattedValue = (value, status, isDiffView, columnConfig) => {
  if (getCellValueIsEmpty(value)) {
    return value;
  }
  const error = isDiffView ? [] : (status == null ? void 0 : status.error) ?? [];
  const warning = isDiffView ? [] : (status == null ? void 0 : status.warning) ?? [];
  const options = columnConfig == null ? void 0 : columnConfig.options;
  const [errorMap, globalError] = createMessageMap({ value }, error);
  const [warningMap, globalWarning] = createMessageMap({ value }, warning);
  if (Array.isArray(value)) {
    const filteredValues = value.filter((v) => v !== "$flatfile-null$");
    return filteredValues.map((v, i) => {
      const errorForIndex = globalError || errorMap.get(v);
      const warningForIndex = globalWarning || warningMap.get(v);
      if (Array.isArray(options)) {
        const option = options.find((o) => o.value === v);
        return option ? { ...option, error: errorForIndex, warning: warningForIndex } : {
          value: v,
          label: v === null ? "null" : v == null ? void 0 : v.toString(),
          error: errorForIndex,
          warning: warningForIndex
        };
      }
      return {
        value: v,
        label: v === null ? "null" : v == null ? void 0 : v.toString(),
        error: errorForIndex,
        warning: warningForIndex
      };
    });
  } else {
    const errorForIndex = globalError || errorMap.get(value);
    const warningForIndex = globalWarning || warningMap.get(value);
    const option = Array.isArray(options) ? options.find((o) => o.value === value) : void 0;
    return option ? [{ ...option, error: errorForIndex, warning: warningForIndex }] : [
      {
        value,
        label: value.toString(),
        error: !!globalError,
        warning: !!globalWarning
      }
    ];
  }
};
const getCell = ({ cell, columnConfig, isDiffView }) => {
  const value = cell == null ? void 0 : cell.value;
  const diffValue = cell == null ? void 0 : cell.diffValue;
  return {
    ...cell,
    value: getFormattedValue(value, cell == null ? void 0 : cell.status, isDiffView, columnConfig),
    diffValue: isDiffView ? getFormattedValue(diffValue, cell == null ? void 0 : cell.status, isDiffView, columnConfig) : void 0
  };
};
const Renderer = (props) => {
  return /* @__PURE__ */ jsx(Renderer$1, { ...props, cell: getCell(props) });
};
export {
  createMessageMap,
  Renderer as default
};
